'use strict';

var Reflux = require('reflux');

var TeamActions = Reflux.createActions(["loadAll", "create", "delete", "edit", "submit", "cancel", "assignUser", "unassignUser", "changeUserRole"]);

module.exports = TeamActions;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/actions/team.js
 **/